export const NAV_LOGIN = "/login";
export const NAV_LOGIN_WITH_AXLE = "/login/axle";
export const NAV_API_DOCS = "/api/docs";
export const NAV_FORGOT_USERNAME = "/forgot-username";
export const NAV_FORGOT_PASSWORD = "/forgot-password";
export const NAV_SELF_SERVICE_ONBOARDING = "/self-service-onboarding";
